"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var EntityService = /*#__PURE__*/function () {
  function EntityService(client) {
    (0, _classCallCheck2["default"])(this, EntityService);
    this.client = client;
    this.resourceUrl = '/entity';
  }

  (0, _createClass2["default"])(EntityService, [{
    key: "createEntity",
    value: function createEntity(type, reqObj) {
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      return this.client.post("".concat(this.resourceUrl, "/").concat(type), reqObj, args);
    }
  }, {
    key: "getEntityGroups",
    value: function getEntityGroups(type, name) {
      var _this$client;

      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return (_this$client = this.client).get.apply(_this$client, ["".concat(this.resourceUrl, "/").concat(type, "/").concat(name, "/groups")].concat(args));
    }
  }, {
    key: "getEntityCoachAndCircles",
    value: function getEntityCoachAndCircles(type, name) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(type, "/").concat(name, "/circle"), args);
    }
  }, {
    key: "getUsersByEntityId",
    value: function getUsersByEntityId(id, type, params) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
        args[_key4 - 3] = arguments[_key4];
      }

      return this.client.post("".concat(this.resourceUrl, "/").concat(type, "/").concat(id, "/users"), params, args);
    }
  }, {
    key: "getEnterpriseSOW",
    value: function getEnterpriseSOW(id, data) {
      var _this$client2;

      for (var _len5 = arguments.length, args = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
        args[_key5 - 2] = arguments[_key5];
      }

      return (_this$client2 = this.client).get.apply(_this$client2, ["".concat(this.resourceUrl, "/").concat(id, "/enterprise-sow"), data].concat(args)); //Get B2B sow
    }
  }, {
    key: "updateEnterpriseSOWMonthly",
    value: function updateEnterpriseSOWMonthly(id, data) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
        args[_key6 - 2] = arguments[_key6];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(id, "/enterprise-sow/monthly"), data, args); //Update monthly enterprise plan
    }
  }, {
    key: "updateCycleStartDate",
    value: function updateCycleStartDate(id, data) {
      for (var _len7 = arguments.length, args = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
        args[_key7 - 2] = arguments[_key7];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(id, "/cycle-start-date"), data, args); //Update cycle start date
    }
  }, {
    key: "updateParticipantLevel",
    value: function updateParticipantLevel(id, userId, data) {
      for (var _len8 = arguments.length, args = new Array(_len8 > 3 ? _len8 - 3 : 0), _key8 = 3; _key8 < _len8; _key8++) {
        args[_key8 - 3] = arguments[_key8];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(id, "/member/").concat(userId, "/participant-level"), data, args); //Update participant level
    }
  }, {
    key: "updateMemberStatus",
    value: function updateMemberStatus(id, userId, data) {
      for (var _len9 = arguments.length, args = new Array(_len9 > 3 ? _len9 - 3 : 0), _key9 = 3; _key9 < _len9; _key9++) {
        args[_key9 - 3] = arguments[_key9];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(id, "/member/").concat(userId, "/status"), data, args); //Update member status
    }
  }, {
    key: "getEntityByName",
    value: function getEntityByName(type, name) {
      for (var _len10 = arguments.length, args = new Array(_len10 > 2 ? _len10 - 2 : 0), _key10 = 2; _key10 < _len10; _key10++) {
        args[_key10 - 2] = arguments[_key10];
      }

      return this.client.post("".concat(this.resourceUrl, "/").concat(type, "/name"), {
        name: name
      }, args);
    }
  }, {
    key: "getEntityArchiveImpact",
    value: function getEntityArchiveImpact(type, id) {
      for (var _len11 = arguments.length, args = new Array(_len11 > 2 ? _len11 - 2 : 0), _key11 = 2; _key11 < _len11; _key11++) {
        args[_key11 - 2] = arguments[_key11];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(type, "/").concat(id, "/archive"), args);
    }
  }, {
    key: "setEntityArchived",
    value: function setEntityArchived(type, id, isArchived) {
      for (var _len12 = arguments.length, args = new Array(_len12 > 3 ? _len12 - 3 : 0), _key12 = 3; _key12 < _len12; _key12++) {
        args[_key12 - 3] = arguments[_key12];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(type, "/").concat(id, "/archive"), {
        isArchived: isArchived
      }, args);
    }
  }, {
    key: "getEntityByNetworkId",
    value: function getEntityByNetworkId(type, networkId) {
      for (var _len13 = arguments.length, args = new Array(_len13 > 2 ? _len13 - 2 : 0), _key13 = 2; _key13 < _len13; _key13++) {
        args[_key13 - 2] = arguments[_key13];
      }

      return this.client.post("".concat(this.resourceUrl, "/").concat(type, "/").concat(networkId), args);
    }
  }, {
    key: "getEntityMetaData",
    value: function getEntityMetaData(type, id) {
      for (var _len14 = arguments.length, args = new Array(_len14 > 2 ? _len14 - 2 : 0), _key14 = 2; _key14 < _len14; _key14++) {
        args[_key14 - 2] = arguments[_key14];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(type, "/").concat(id, "/meta-data"), args);
    }
  }, {
    key: "getEntityByCode",
    value: function getEntityByCode(type, orgEcoId, data) {
      var _this$client3;

      for (var _len15 = arguments.length, args = new Array(_len15 > 3 ? _len15 - 3 : 0), _key15 = 3; _key15 < _len15; _key15++) {
        args[_key15 - 3] = arguments[_key15];
      }

      return (_this$client3 = this.client).get.apply(_this$client3, ["".concat(this.resourceUrl, "/").concat(type, "/").concat(orgEcoId, "/coaches"), data].concat(args));
    }
  }, {
    key: "addEntityCoach",
    value: function addEntityCoach(type, orgEcoId, data) {
      var _this$client4;

      for (var _len16 = arguments.length, args = new Array(_len16 > 3 ? _len16 - 3 : 0), _key16 = 3; _key16 < _len16; _key16++) {
        args[_key16 - 3] = arguments[_key16];
      }

      return (_this$client4 = this.client).put.apply(_this$client4, ["".concat(this.resourceUrl, "/").concat(type, "/").concat(orgEcoId, "/assign-coach"), data].concat(args));
    }
  }, {
    key: "deleteEntityCoach",
    value: function deleteEntityCoach(type, orgEcoId, coachId) {
      for (var _len17 = arguments.length, args = new Array(_len17 > 3 ? _len17 - 3 : 0), _key17 = 3; _key17 < _len17; _key17++) {
        args[_key17 - 3] = arguments[_key17];
      }

      return this.client["delete"]("".concat(this.resourceUrl, "/").concat(type, "/").concat(orgEcoId, "/unassign-coach/").concat(coachId), args);
    }
  }, {
    key: "updateEntityCompanyMetdata",
    value: function updateEntityCompanyMetdata(type, orgEcoId, keyWrapper, data) {
      var key = '';

      switch (keyWrapper) {
        case 'purposeAndVision':
          key = 'purpose-and-vision';
          break;

        case 'valuesAndPrinciples':
          key = 'values-and-principles';
          break;

        case 'objectives':
          key = 'objectives';
          break;

        default:
          break;
      }

      for (var _len18 = arguments.length, args = new Array(_len18 > 4 ? _len18 - 4 : 0), _key18 = 4; _key18 < _len18; _key18++) {
        args[_key18 - 4] = arguments[_key18];
      }

      return this.client.post("".concat(this.resourceUrl, "/").concat(type, "/").concat(orgEcoId, "/").concat(key), data, args);
    }
  }, {
    key: "updateEntityPlan",
    value: function updateEntityPlan(type, id, data) {
      for (var _len19 = arguments.length, args = new Array(_len19 > 3 ? _len19 - 3 : 0), _key19 = 3; _key19 < _len19; _key19++) {
        args[_key19 - 3] = arguments[_key19];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(type, "/").concat(id, "/plan"), data, args);
    }
  }, {
    key: "toggleEntityWisdomAssessmentEnabled",
    value: function toggleEntityWisdomAssessmentEnabled(type, id, data) {
      var _this$client5;

      for (var _len20 = arguments.length, args = new Array(_len20 > 3 ? _len20 - 3 : 0), _key20 = 3; _key20 < _len20; _key20++) {
        args[_key20 - 3] = arguments[_key20];
      }

      return (_this$client5 = this.client).put.apply(_this$client5, ["".concat(this.resourceUrl, "/").concat(type, "/").concat(id, "/wisdom"), data].concat(args));
    }
  }, {
    key: "getEntityCoachList",
    value: function getEntityCoachList(type, orgEcoId, data) {
      var _this$client6;

      for (var _len21 = arguments.length, args = new Array(_len21 > 3 ? _len21 - 3 : 0), _key21 = 3; _key21 < _len21; _key21++) {
        args[_key21 - 3] = arguments[_key21];
      }

      return (_this$client6 = this.client).get.apply(_this$client6, ["".concat(this.resourceUrl, "/").concat(type, "/").concat(orgEcoId, "/coaches"), data].concat(args));
    }
  }, {
    key: "getMemberProgress",
    value: function getMemberProgress(type, id) {
      var _this$client7;

      var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var query = new URLSearchParams(queryParams).toString();

      for (var _len22 = arguments.length, args = new Array(_len22 > 3 ? _len22 - 3 : 0), _key22 = 3; _key22 < _len22; _key22++) {
        args[_key22 - 3] = arguments[_key22];
      }

      return (_this$client7 = this.client).get.apply(_this$client7, ["".concat(this.resourceUrl, "/").concat(type, "/").concat(id, "/member-progress").concat(query ? "?".concat(query) : '')].concat(args));
    }
  }, {
    key: "exportMemberProgress",
    value: function exportMemberProgress(type, id, data) {
      var _this$client8;

      for (var _len23 = arguments.length, args = new Array(_len23 > 3 ? _len23 - 3 : 0), _key23 = 3; _key23 < _len23; _key23++) {
        args[_key23 - 3] = arguments[_key23];
      }

      return (_this$client8 = this.client).post.apply(_this$client8, ["".concat(this.resourceUrl, "/").concat(type, "/").concat(id, "/member-progress/export"), data].concat(args));
    }
  }, {
    key: "getEntityInactive",
    value: function getEntityInactive(type, id) {
      var _this$client9;

      for (var _len24 = arguments.length, args = new Array(_len24 > 2 ? _len24 - 2 : 0), _key24 = 2; _key24 < _len24; _key24++) {
        args[_key24 - 2] = arguments[_key24];
      }

      return (_this$client9 = this.client).put.apply(_this$client9, ["".concat(this.resourceUrl, "/").concat(type, "/").concat(id, "/inactive")].concat(args));
    } // invite-link APIs for organization and network

  }, {
    key: "getEntityInviteLinkInfo",
    value: function getEntityInviteLinkInfo(type, id) {
      var _this$client10;

      for (var _len25 = arguments.length, args = new Array(_len25 > 2 ? _len25 - 2 : 0), _key25 = 2; _key25 < _len25; _key25++) {
        args[_key25 - 2] = arguments[_key25];
      }

      return (_this$client10 = this.client).get.apply(_this$client10, ["".concat(this.resourceUrl, "/").concat(type, "/").concat(id, "/invite-link")].concat(args));
    }
  }, {
    key: "updateEntityInviteDetails",
    value: function updateEntityInviteDetails(type, id, data) {
      var _this$client11;

      for (var _len26 = arguments.length, args = new Array(_len26 > 3 ? _len26 - 3 : 0), _key26 = 3; _key26 < _len26; _key26++) {
        args[_key26 - 3] = arguments[_key26];
      }

      return (_this$client11 = this.client).put.apply(_this$client11, ["".concat(this.resourceUrl, "/").concat(type, "/").concat(id, "/invite-link"), data].concat(args));
    }
  }, {
    key: "deleteEntityInviteLink",
    value: function deleteEntityInviteLink(type, id) {
      for (var _len27 = arguments.length, args = new Array(_len27 > 2 ? _len27 - 2 : 0), _key27 = 2; _key27 < _len27; _key27++) {
        args[_key27 - 2] = arguments[_key27];
      }

      return this.client["delete"]("".concat(this.resourceUrl, "/").concat(type, "/").concat(id, "/invite-link"), //---------------------------------future use
      args);
    }
  }, {
    key: "getEntityInviteLinkLogoFileURL",
    value: function getEntityInviteLinkLogoFileURL(type, id, contentType) {
      for (var _len28 = arguments.length, args = new Array(_len28 > 3 ? _len28 - 3 : 0), _key28 = 3; _key28 < _len28; _key28++) {
        args[_key28 - 3] = arguments[_key28];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(type, "/").concat(id, "/logo/signed-url?fileType=").concat(contentType), args);
    }
  }, {
    key: "addEntityIndividualUser",
    value: function addEntityIndividualUser(type, id, data) {
      var _this$client12;

      for (var _len29 = arguments.length, args = new Array(_len29 > 3 ? _len29 - 3 : 0), _key29 = 3; _key29 < _len29; _key29++) {
        args[_key29 - 3] = arguments[_key29];
      }

      return (_this$client12 = this.client).post.apply(_this$client12, ["".concat(this.resourceUrl, "/").concat(type, "/").concat(id, "/individual-user"), data].concat(args));
    } //Network use only

  }, {
    key: "getNetworkEntityByCode",
    value: function getNetworkEntityByCode(type) {
      return this.client.post("".concat(this.resourceUrl, "/").concat(type, "/code")); // for network only - use baki che, only created for future use
    }
  }, {
    key: "getEntityWelcomeEmailBody",
    value: function getEntityWelcomeEmailBody(type, name) {
      for (var _len30 = arguments.length, args = new Array(_len30 > 2 ? _len30 - 2 : 0), _key30 = 2; _key30 < _len30; _key30++) {
        args[_key30 - 2] = arguments[_key30];
      }

      return this.client.post("".concat(this.resourceUrl, "/").concat(type, "/welcome-email"), {
        name: name
      }, args);
    }
  }, {
    key: "updateEntityWelcomeEmailBody",
    value: function updateEntityWelcomeEmailBody(type, data) {
      for (var _len31 = arguments.length, args = new Array(_len31 > 2 ? _len31 - 2 : 0), _key31 = 2; _key31 < _len31; _key31++) {
        args[_key31 - 2] = arguments[_key31];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(type, "/welcome-email"), data, args);
    }
  }, {
    key: "updateNetworkEntityProgramData",
    value: function updateNetworkEntityProgramData(type, id, data) {
      for (var _len32 = arguments.length, args = new Array(_len32 > 3 ? _len32 - 3 : 0), _key32 = 3; _key32 < _len32; _key32++) {
        args[_key32 - 3] = arguments[_key32];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(type, "/").concat(id, "/program-data"), data, args);
    }
  }]);
  return EntityService;
}();

exports["default"] = EntityService;